//baseUrl's
export const baseUrl = process.env.REACT_APP_BASE_URL;

//GET API's
export const API_GET_ALL_SHOP_DETAILS = '/api/shop/all'
export const API_GET_ALL_LOCATION_DETAILS = '/api/location/all'
export const API_GET_ALL_FACILITY_DETAILS = '/api/facility/all'